// GALILEO-2516 START
import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// Section 1
	valueProp1Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-1-title',
		defaultMessage: 'Prioritize with confidence',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp1Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-1-description',
		defaultMessage:
			"Identify your highest impact ideas using our RICE template, or your team's preferred prioritization framework.",
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 2
	valueProp2Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-2-title',
		defaultMessage: 'Align your team with roadmaps',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp2Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-2-description',
		defaultMessage:
			'Create and share custom roadmaps with different stakeholders - even your customers.',
		description: 'Description for section that explains more details about the value of template',
	},
	// Section 3
	valueProp3Title: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-3-title',
		defaultMessage: 'Connect with delivery',
		description: 'Title for section that summarizes the value of this template',
	},
	valueProp3Description: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.value-prop-3-description',
		defaultMessage:
			'Seamlessly connect your ideas to delivery work in Jira so your teams have full context and visibility from discovery to delivery.',
		description: 'Description for section that explains more details about the value of template',
	},
	recommendedList1: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.recommended-list-1',
		defaultMessage: 'Teams that need to prioritize work',
		description: 'Recommended project types to use this template',
	},
	recommendedList2: {
		id: 'project-template-select-v2.utils.templates.product-discovery.prioritization.recommended-list-2',
		defaultMessage: 'Product teams',
		description: 'Recommended project types to use this template',
	},
});

// GALILEO-2516 END
